import { Product } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const PRODUCTS: Product[] = [
  {
    id: 'p001',
    name: 'Advanced X-Ray Baggage Scanner',
    category: 'security-screening',
    supplierId: 's001',
    supplierName: 'SecureScan Technologies',
    description: 'State-of-the-art dual-view X-ray baggage inspection system with advanced threat detection algorithms. Features high-resolution imaging, automatic threat recognition, and real-time analysis capabilities. Designed for high-throughput airport security checkpoints with minimal false alarm rates.',
    shortDescription: 'Dual-view X-ray scanner with AI-powered threat detection for baggage screening',
    images: [IMAGES.SECURITY_TECH_4, IMAGES.SECURITY_SCREENING_8, IMAGES.SECURITY_TECH_5],
    specifications: {
      'Tunnel Size': '100cm x 80cm',
      'Conveyor Speed': '0.22 m/s',
      'Penetration': '38mm steel',
      'Resolution': '0.1mm wire detection',
      'Power Supply': '220V AC, 50/60Hz',
      'Weight': '850 kg',
      'Certification': 'TSA, ECAC, CE',
    },
    features: [
      'Dual-energy imaging technology',
      'Automatic threat detection (ATD)',
      'Material discrimination',
      'Image enhancement and zoom',
      'Network connectivity for remote monitoring',
      'Low radiation emission',
      'User-friendly touchscreen interface',
    ],
    applications: [
      'Airport security checkpoints',
      'Cargo screening facilities',
      'Border control stations',
      'Government buildings',
      'Critical infrastructure protection',
    ],
    price: 'Contact for Quote',
    featured: true,
  },
  {
    id: 'p002',
    name: 'Full Body Security Scanner',
    category: 'security-screening',
    supplierId: 's001',
    supplierName: 'SecureScan Technologies',
    description: 'Millimeter wave full body scanner providing comprehensive passenger screening without physical contact. Advanced imaging technology detects metallic and non-metallic threats while ensuring passenger privacy through automated target recognition software.',
    shortDescription: 'Non-invasive millimeter wave body scanner with privacy protection',
    images: [IMAGES.SECURITY_SCREENING_9, IMAGES.SECURITY_TECH_6, IMAGES.AIRPORT_TERMINAL_5],
    specifications: {
      'Technology': 'Millimeter Wave',
      'Scan Time': '< 3 seconds',
      'Throughput': '200+ passengers/hour',
      'Detection': 'Metallic & non-metallic threats',
      'Privacy': 'Automated target recognition',
      'Dimensions': '2.5m x 1.2m x 2.8m',
      'Power': '230V AC, 16A',
    },
    features: [
      'Safe millimeter wave technology',
      'Automated threat detection',
      'Privacy-enhanced imaging',
      'Fast screening process',
      'ADA compliant design',
      'Remote monitoring capability',
      'Minimal operator training required',
    ],
    applications: [
      'Airport passenger screening',
      'High-security venues',
      'Government facilities',
      'Transportation hubs',
      'Event security',
    ],
    price: 'Contact for Quote',
    featured: true,
  },
  {
    id: 'p003',
    name: 'Explosive Trace Detection System',
    category: 'security-screening',
    supplierId: 's002',
    supplierName: 'AeroGuard Systems',
    description: 'Portable explosive trace detection (ETD) system utilizing ion mobility spectrometry for rapid identification of explosive materials. Provides laboratory-quality results in seconds with minimal false alarms. Ideal for checkpoint screening and random security checks.',
    shortDescription: 'Portable ETD system for rapid explosive material detection',
    images: [IMAGES.SECURITY_TECH_4, IMAGES.SECURITY_TECH_5, IMAGES.SECURITY_SCREENING_8],
    specifications: {
      'Detection Method': 'Ion Mobility Spectrometry',
      'Analysis Time': '8-10 seconds',
      'Detection Limit': 'Nanogram level',
      'Sample Collection': 'Swab-based',
      'Weight': '12 kg',
      'Battery Life': '8 hours continuous',
      'Operating Temp': '-10°C to 50°C',
    },
    features: [
      'Detects wide range of explosives',
      'Low false alarm rate',
      'Portable and lightweight',
      'Simple swab collection',
      'Rapid analysis',
      'Database of 40+ explosive compounds',
      'Wireless data transmission',
    ],
    applications: [
      'Airport security checkpoints',
      'Cargo inspection',
      'Vehicle screening',
      'Mail and package screening',
      'Event security',
    ],
    featured: true,
  },
  {
    id: 'p004',
    name: 'Biometric Access Control System',
    category: 'access-control',
    supplierId: 's003',
    supplierName: 'IdentityPro Solutions',
    description: 'Multi-modal biometric access control system combining fingerprint, facial recognition, and iris scanning technologies. Provides secure, fast, and accurate authentication for restricted areas. Scalable architecture supports thousands of users with centralized management.',
    shortDescription: 'Multi-modal biometric system for secure facility access',
    images: [IMAGES.SECURITY_TECH_6, IMAGES.AIRPORT_TERMINAL_5, IMAGES.SECURITY_TECH_4],
    specifications: {
      'Biometric Modes': 'Fingerprint, Face, Iris',
      'Authentication Time': '< 1 second',
      'User Capacity': '50,000+ users',
      'False Accept Rate': '< 0.001%',
      'Operating System': 'Linux-based',
      'Connectivity': 'TCP/IP, WiFi',
      'Display': '7-inch touchscreen',
    },
    features: [
      'Multi-modal authentication',
      'Anti-spoofing technology',
      'Real-time monitoring',
      'Audit trail logging',
      'Integration with existing systems',
      'Mobile app management',
      'Weatherproof design',
    ],
    applications: [
      'Airport restricted areas',
      'Staff access control',
      'VIP lounges',
      'Maintenance facilities',
      'Control rooms',
    ],
    featured: true,
  },
  {
    id: 'p005',
    name: 'AI-Powered Video Analytics Platform',
    category: 'surveillance',
    supplierId: 's004',
    supplierName: 'VisionTech Security',
    description: 'Advanced video analytics platform powered by artificial intelligence and deep learning. Provides real-time object detection, behavior analysis, crowd monitoring, and automated alert generation. Integrates seamlessly with existing CCTV infrastructure.',
    shortDescription: 'AI-driven video analytics for intelligent surveillance',
    images: [IMAGES.SECURITY_TECH_5, IMAGES.SECURITY_SCREENING_9, IMAGES.SECURITY_TECH_6],
    specifications: {
      'AI Engine': 'Deep Learning Neural Networks',
      'Camera Support': 'Up to 1000 cameras',
      'Video Resolution': 'Up to 4K',
      'Processing': 'Real-time analysis',
      'Storage': 'Scalable cloud/on-premise',
      'API': 'RESTful API',
      'Deployment': 'On-premise or cloud',
    },
    features: [
      'Object detection and tracking',
      'Facial recognition',
      'Behavior analysis',
      'Crowd density monitoring',
      'Perimeter intrusion detection',
      'Abandoned object detection',
      'License plate recognition',
      'Heat mapping',
    ],
    applications: [
      'Airport terminal monitoring',
      'Perimeter security',
      'Parking lot surveillance',
      'Crowd management',
      'Incident investigation',
    ],
    featured: true,
  },
  {
    id: 'p006',
    name: 'Network Security Firewall',
    category: 'cybersecurity',
    supplierId: 's005',
    supplierName: 'CyberShield Networks',
    description: 'Next-generation firewall with advanced threat protection, intrusion prevention, and deep packet inspection. Designed specifically for critical infrastructure protection with high availability and redundancy features. Protects airport IT systems from cyber threats.',
    shortDescription: 'Enterprise-grade firewall for critical infrastructure protection',
    images: [IMAGES.SECURITY_TECH_4, IMAGES.SECURITY_TECH_6, IMAGES.SECURITY_TECH_5],
    specifications: {
      'Throughput': '100 Gbps',
      'Concurrent Sessions': '10 million+',
      'VPN Support': 'IPSec, SSL',
      'Interfaces': '48 x 10GbE, 4 x 100GbE',
      'Redundancy': 'Active-Active HA',
      'Management': 'Web GUI, CLI, API',
      'Compliance': 'PCI DSS, HIPAA, ISO 27001',
    },
    features: [
      'Advanced threat prevention',
      'Intrusion prevention system (IPS)',
      'Application control',
      'URL filtering',
      'Anti-malware protection',
      'DDoS mitigation',
      'Zero-day threat protection',
      'Centralized management',
    ],
    applications: [
      'Airport network security',
      'Data center protection',
      'Cloud connectivity',
      'Remote site security',
      'IoT device protection',
    ],
    featured: false,
  },
  {
    id: 'p007',
    name: 'Self-Service Check-in Kiosk',
    category: 'terminal-equipment',
    supplierId: 's006',
    supplierName: 'AeroTech Solutions',
    description: 'Modern self-service check-in kiosk with intuitive touchscreen interface, passport scanner, boarding pass printer, and baggage tag dispenser. Reduces queue times and improves passenger experience. Supports multiple languages and accessibility features.',
    shortDescription: 'Multi-functional self-service kiosk for passenger check-in',
    images: [IMAGES.AIRPORT_TERMINAL_5, IMAGES.SECURITY_SCREENING_8, IMAGES.SECURITY_TECH_4],
    specifications: {
      'Display': '27-inch touchscreen',
      'Passport Scanner': 'ICAO compliant',
      'Printer': 'Thermal boarding pass',
      'Baggage Tag': 'RFID-enabled',
      'Payment': 'EMV, NFC, QR code',
      'Connectivity': 'Ethernet, WiFi, 4G',
      'Dimensions': '1.8m x 0.6m x 0.5m',
    },
    features: [
      'Multi-language support',
      'ADA compliant design',
      'Biometric integration',
      'Real-time flight information',
      'Seat selection',
      'Upgrade options',
      'Remote monitoring',
      'Modular design',
    ],
    applications: [
      'Airport check-in areas',
      'Transfer desks',
      'Self-bag drop zones',
      'Airline lounges',
      'Remote check-in locations',
    ],
    featured: false,
  },
  {
    id: 'p008',
    name: 'Emergency Communication System',
    category: 'emergency-response',
    supplierId: 's007',
    supplierName: 'SafetyFirst Systems',
    description: 'Integrated emergency communication and public address system for airports. Provides clear audio announcements, emergency alerts, and two-way communication capabilities. Supports multiple zones with priority override for critical situations.',
    shortDescription: 'Integrated emergency alert and communication platform',
    images: [IMAGES.SECURITY_TECH_5, IMAGES.AIRPORT_TERMINAL_5, IMAGES.SECURITY_TECH_6],
    specifications: {
      'Audio Zones': 'Up to 500 zones',
      'Power Output': '500W per zone',
      'Frequency Response': '50Hz - 18kHz',
      'Microphone Stations': 'Up to 100',
      'Backup Power': 'UPS with 4-hour runtime',
      'Integration': 'Fire alarm, security systems',
      'Standards': 'EN 54-16, UL 2572',
    },
    features: [
      'Multi-zone paging',
      'Priority messaging',
      'Pre-recorded announcements',
      'Two-way communication',
      'Automatic fault detection',
      'Remote management',
      'Integration with fire systems',
      'Redundant architecture',
    ],
    applications: [
      'Airport terminals',
      'Parking structures',
      'Maintenance facilities',
      'Control towers',
      'Emergency evacuation',
    ],
    featured: false,
  },
  {
    id: 'p009',
    name: 'Perimeter Intrusion Detection',
    category: 'surveillance',
    supplierId: 's008',
    supplierName: 'BorderGuard Technologies',
    description: 'Advanced perimeter intrusion detection system using fiber optic sensing technology. Provides continuous monitoring of airport boundaries with precise location detection. Weather-resistant and immune to electromagnetic interference.',
    shortDescription: 'Fiber optic perimeter security with precise intrusion detection',
    images: [IMAGES.SECURITY_TECH_6, IMAGES.SECURITY_SCREENING_9, IMAGES.SECURITY_TECH_4],
    specifications: {
      'Detection Range': 'Up to 100km per unit',
      'Location Accuracy': '±5 meters',
      'Response Time': '< 1 second',
      'False Alarm Rate': '< 0.1%',
      'Operating Temp': '-40°C to 75°C',
      'Protection Rating': 'IP68',
      'Integration': 'CCTV, access control',
    },
    features: [
      'Continuous monitoring',
      'Precise intrusion location',
      'Multiple threat detection',
      'Weather immune',
      'Low maintenance',
      'Scalable architecture',
      'GIS mapping integration',
      'Real-time alerts',
    ],
    applications: [
      'Airport perimeter security',
      'Runway protection',
      'Cargo area monitoring',
      'Critical infrastructure',
      'Border security',
    ],
    featured: false,
  },
  {
    id: 'p010',
    name: 'Automated Border Control Gate',
    category: 'access-control',
    supplierId: 's003',
    supplierName: 'IdentityPro Solutions',
    description: 'Automated border control (ABC) gate with integrated biometric verification and document authentication. Streamlines passenger processing while maintaining high security standards. Supports e-passports and biometric data verification.',
    shortDescription: 'Automated e-passport control gate with biometric verification',
    images: [IMAGES.AIRPORT_TERMINAL_5, IMAGES.SECURITY_TECH_5, IMAGES.SECURITY_SCREENING_8],
    specifications: {
      'Processing Time': '15-20 seconds',
      'Biometrics': 'Face, fingerprint',
      'Document Reader': 'ICAO 9303 compliant',
      'Throughput': '180 passengers/hour',
      'Gate Type': 'Optical barrier',
      'Height Range': '1.2m - 2.1m',
      'Power': '230V AC',
    },
    features: [
      'E-passport reading',
      'Facial recognition',
      'Fingerprint verification',
      'Document authentication',
      'Anti-tailgating detection',
      'Multilingual interface',
      'Accessibility features',
      'Real-time database check',
    ],
    applications: [
      'International arrivals',
      'Departure control',
      'Transfer passenger processing',
      'VIP fast track',
      'Crew processing',
    ],
    featured: false,
  },
  {
    id: 'p011',
    name: 'Cargo X-Ray Inspection System',
    category: 'security-screening',
    supplierId: 's001',
    supplierName: 'SecureScan Technologies',
    description: 'Large-scale X-ray inspection system designed for air cargo and freight screening. High-energy imaging penetrates dense cargo loads while maintaining image clarity. Meets international air cargo security standards.',
    shortDescription: 'High-energy X-ray system for air cargo screening',
    images: [IMAGES.SECURITY_TECH_4, IMAGES.SECURITY_SCREENING_8, IMAGES.SECURITY_TECH_6],
    specifications: {
      'Tunnel Size': '150cm x 180cm',
      'Penetration': '300mm steel',
      'Generator': 'Dual energy 6MeV',
      'Conveyor Load': '1500 kg',
      'Scan Speed': '0.15 m/s',
      'Image Processing': 'Real-time',
      'Certification': 'TSA, ECAC',
    },
    features: [
      'High penetration capability',
      'Material discrimination',
      'Automatic threat detection',
      'Image archiving',
      'Remote diagnostics',
      'Radiation shielding',
      'Network integration',
    ],
    applications: [
      'Air cargo screening',
      'Freight forwarding',
      'Customs inspection',
      'Mail screening',
      'Supply chain security',
    ],
    featured: false,
  },
  {
    id: 'p012',
    name: 'Fire Detection and Suppression',
    category: 'emergency-response',
    supplierId: 's007',
    supplierName: 'SafetyFirst Systems',
    description: 'Intelligent fire detection and suppression system with multi-sensor technology and automated response capabilities. Provides early warning and rapid suppression for airport facilities. Compliant with aviation fire safety standards.',
    shortDescription: 'Intelligent fire safety system with automated suppression',
    images: [IMAGES.SECURITY_TECH_5, IMAGES.SECURITY_TECH_6, IMAGES.AIRPORT_TERMINAL_5],
    specifications: {
      'Detection': 'Smoke, heat, flame',
      'Response Time': '< 10 seconds',
      'Suppression': 'Water mist, foam, gas',
      'Coverage': 'Up to 10,000 sqm',
      'Zones': 'Up to 250',
      'Backup Power': '72 hours',
      'Standards': 'NFPA, EN 54',
    },
    features: [
      'Multi-sensor detection',
      'Intelligent algorithms',
      'Automatic suppression',
      'Zone isolation',
      'Remote monitoring',
      'Integration with BMS',
      'Self-diagnostics',
      'Redundant control',
    ],
    applications: [
      'Terminal buildings',
      'Hangars',
      'Fuel storage areas',
      'Electrical rooms',
      'Data centers',
    ],
    featured: false,
  },
];